import styled from '@emotion/styled';
import React, { FC, useState } from 'react';
import * as actions from '~actions';
import ClaimDeviceV2 from '~Components/ClaimDevice';
import { ModalWrapper } from '~Components/ClaimDevice/styles';
import { useDeviceHandler } from '~Components/DeviceProvider';
import { useStorage } from '~Components/Storage';
import Modal from '~ComponentsImproved/Modal';
import useModal from '~ComponentsImproved/Modal/useModal';
import NumberInput from '~ComponentsImproved/Numpad';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { useButton, useDispatch, useI18n, useLogger, useSelector } from '~Hooks';
import ClaimDevice from '~Scenes/Onboarding/Components/ClaimDevice';
import { Button } from '~Styles';

const ModalContent = styled.div`
  box-shadow: 0px 1px 18px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background-color: var(--colorBlueGray1200);
  width: 550px;
  min-height: 650px;
  max-height: 90%;
  padding-top: 40px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const DeviceSettings: FC = () => {
  const { i18n } = useI18n();

  // const deviceHandler = useDeviceHandler();
  const dispatch = useDispatch();
  const modal = useModal();
  const logger = useLogger('settings-v2');
  const companyFlags = useSelector((state) => state.companyFlags);

  const [storage] = useStorage();
  const deviceHandler = useDeviceHandler();

  const deviceNameToShow = companyFlags.useNewLicenses
    ? deviceHandler.activeDevice?.name
    : storage.taxComplianceDeviceName;

  const [showPasswordInput, setShowPasswordInput] = useState(false);

  const button = useButton({
    onClick: () => {
      setShowPasswordInput(true);
    },
  });

  return (
    <div>
      <Paragraph level={4} color="var(--colorBlueGray200)" bottom={16}>
        {i18n('Settings.Device.Current')}: <strong>{deviceNameToShow}</strong>
      </Paragraph>
      <Button {...button}>{i18n('Settings.Device.Change')}</Button>

      <Modal isShowing={modal.isShowing} hide={() => modal.toggle()}>
        <ModalWrapper
          display="flex"
          flexDirection="column"
          gap="medium"
          alignItems="center"
          justifyContent="center"
          padding="3xl"
          marginTop="small"
          marginBottom="small">
          {companyFlags.useNewLicenses ? (
            <ClaimDeviceV2
              isChangeOfDevice
              onComplete={() => {
                modal.toggle();
                dispatch(actions.addToast(i18n('Onboarding.Device.Success'), true));
              }}
            />
          ) : (
            <ClaimDevice
              onComplete={() => {
                modal.toggle();
                dispatch(actions.addToast(i18n('Onboarding.Device.Success'), true));
              }}
            />
          )}
        </ModalWrapper>
      </Modal>

      {showPasswordInput && (
        <NumberInput
          onClose={() => setShowPasswordInput(false)}
          onSubmit={(value) => {
            if (value !== '1111') {
              logger.info('Tried to change device without correct password');
              dispatch(actions.addToast(i18n('Settings.NotAllowed'), true, 'notallowed', true));
              setShowPasswordInput(false);
            } else {
              modal.toggle();
              setShowPasswordInput(false);
            }
          }}
        />
      )}
    </div>
  );
};

export default DeviceSettings;
